import React from "react";
import Styles from "./Assistance.module.css";
import Star from "Assets/Homepage/star2.png";
import { FaArrowRightLong } from "react-icons/fa6";

function Assistance() {
    return (
        <div className={Styles["Assistance"]}>
            <div>
                <h3>Payroll Processing</h3>
                <p className={Styles["para"]}>
                    Payroll processing is the administration of a company's
                    employee compensation, including wages, salaries, bonuses,
                    deductions, and taxes. It ensures employees are paid
                    accurately and on time while complying with labor laws and
                    tax regulations.
                </p>
                <div className={Styles["list"]}>
                    <p style={{ gridColumn: "1/-1" }}>
                        <span>01</span> Employee Information Management
                    </p>
                    <p>
                        <span>02</span> Salary Calculation
                    </p>
                    <p>
                        <span>03</span> Deductions
                    </p>
                    <p>
                        <span>04</span> Net Pay Calculation
                    </p>
                    <p>
                        <span>05</span>Tax Filing and Compliance
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Assistance;
